import { useState, useEffect, useCallback } from 'react';
import './App.css';

const HUB_MAC = 'd88039af50cb';

const VALVES = [
  { id: 'd6a1', name: 'Front Yard' },
  { id: 'd83a', name: 'Back Yard' }
];

const ZONES = [
  { idx: 1, name: 'Zone 1' },
  { idx: 2, name: 'Zone 2' },
  { idx: 3, name: 'Zone 3' },
  { idx: 4, name: 'Zone 4' }
];

function AuthScreen() {
  const [mode, setMode] = useState('login');
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleRegister = async () => {
    if (!name || !email) return setError('Please enter your name and email');
    setLoading(true); setError('');
    try {
      const res = await fetch('/auth/request', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ name, email })
      });
      const data = await res.json();
      if (data.success) setMode('pending');
      else if (data.status === 'pending') setMode('pending');
      else if (data.status === 'approved') setMode('login');
      else setError(data.error || 'Request failed');
    } catch(e) { setError('Network error'); }
    setLoading(false);
  };

  const handleLogin = async () => {
    if (!email) return setError('Please enter your email');
    setLoading(true); setError('');
    try {
      const res = await fetch('/auth/login', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email, adminMode: mode === 'admin' })
      });
      const data = await res.json();
      if (data.success) setMode('sent');
      else setError(data.error || 'Email not found or not approved');
    } catch(e) { setError('Network error'); }
    setLoading(false);
  };

  return (
    <div className="auth-screen">
      <div className="auth-card">
        <div className="auth-logo">💧</div>
        <h1 className="auth-title">Kishore's RainCloud</h1>
        <p className="auth-subtitle">Smart Irrigation Control</p>

        {mode === 'pending' && (
          <div className="auth-message">
            <div className="auth-message-icon">⏳</div>
            <h2>Request Sent!</h2>
            <p>You'll receive an email once approved.</p>
            <button className="auth-link-btn" onClick={() => setMode('login')}>Already approved? Login</button>
          </div>
        )}

        {mode === 'sent' && (
          <div className="auth-message">
            <div className="auth-message-icon">📧</div>
            <h2>Check Your Email!</h2>
            <p>We sent a magic link to <strong>{email}</strong></p>
            <p className="auth-note">Link expires in 15 minutes.</p>
            <button className="auth-link-btn" onClick={() => { setMode('login'); setEmail(''); }}>Use different email</button>
          </div>
        )}

        {mode === 'login' && (
          <>
            <div className="auth-form">
              <input className="auth-input" type="email" placeholder="Enter your email"
                value={email} onChange={e => setEmail(e.target.value)}
                onKeyDown={e => e.key === 'Enter' && handleLogin()} />
              {error && <p className="auth-error">{error}</p>}
              <button className="auth-btn" onClick={handleLogin} disabled={loading}>
                {loading ? 'Sending...' : 'Send Magic Link'}
              </button>
            </div>
            <button className="auth-link-btn" onClick={() => { setMode('register'); setError(''); }}>
              No access yet? Request it
            </button>
            <div className="auth-divider">─── or ───</div>
            <button className="admin-login-btn" onClick={() => { setMode('admin'); setError(''); }}>
              🔐 Admin Login
            </button>
          </>
        )}

        {mode === 'admin' && (
          <>
            <div className="auth-form">
              <input className="auth-input" type="email" placeholder="Admin email"
                value={email} onChange={e => setEmail(e.target.value)}
                onKeyDown={e => e.key === 'Enter' && handleLogin()} />
              {error && <p className="auth-error">{error}</p>}
              <button className="auth-btn" style={{background:'#553C9A'}} onClick={handleLogin} disabled={loading}>
                {loading ? 'Sending...' : '🔐 Send Admin Magic Link'}
              </button>
            </div>
            <button className="auth-link-btn" onClick={() => { setMode('login'); setError(''); }}>
              Back to user login
            </button>
          </>
        )}

        {mode === 'register' && (
          <>
            <div className="auth-form">
              <input className="auth-input" type="text" placeholder="Your name"
                value={name} onChange={e => setName(e.target.value)} />
              <input className="auth-input" type="email" placeholder="Your email"
                value={email} onChange={e => setEmail(e.target.value)}
                onKeyDown={e => e.key === 'Enter' && handleRegister()} />
              {error && <p className="auth-error">{error}</p>}
              <button className="auth-btn" onClick={handleRegister} disabled={loading}>
                {loading ? 'Sending...' : 'Request Access'}
              </button>
            </div>
            <button className="auth-link-btn" onClick={() => { setMode('login'); setError(''); }}>
              Already have access? Login
            </button>
          </>
        )}
      </div>
    </div>
  );
}

export default function App() {
  const [token, setToken] = useState(localStorage.getItem('rc_token'));
  const [user, setUser] = useState(null);
  const [status, setStatus] = useState(null);
  const [activeZones, setActiveZones] = useState({});
  const [loading, setLoading] = useState({});
  const [lastRefresh, setLastRefresh] = useState(null);
  const [view, setView] = useState('control');
  const [schedules, setSchedules] = useState([]);
  const [history, setHistory] = useState([]);
  const [weather, setWeather] = useState(null);
  const [rainDelay, setRainDelay] = useState(0);
  const [showAddSchedule, setShowAddSchedule] = useState(false);
  const [scheduleError, setScheduleError] = useState('');
  const [selectedZones, setSelectedZones] = useState({ d6a1: 1, d83a: 1 });
  const [selectedDurs, setSelectedDurs] = useState({ d6a1: 10, d83a: 10 });
  const [adminData, setAdminData] = useState({ users: [], requests: [], activity: [], hubs: [] });
  const [newSched, setNewSched] = useState({ valveId: 'd6a1', zone: 1, intervalDays: 1, timesPerDay: 1, slots: [{time:'06:00', duration:10}] });

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const urlToken = params.get('token');
    if (urlToken) {
      localStorage.setItem('rc_token', urlToken);
      setToken(urlToken);
      window.history.replaceState({}, '', '/');
    }
  }, []);

  useEffect(() => {
    if (!token) return;
    fetch('/auth/me', { headers: { Authorization: `Bearer ${token}` } })
      .then(r => r.json())
      .then(data => {
        if (data.error) { localStorage.removeItem('rc_token'); setToken(null); }
        else setUser(data);
      })
      .catch(() => { localStorage.removeItem('rc_token'); setToken(null); });
  }, [token]);

  const H = { Authorization: `Bearer ${token}` };

  const fetchStatus = useCallback(async () => {
    if (!token) return;
    try {
      const res = await fetch(`/api/hubs/${HUB_MAC}/status`, { headers: H });
      const data = await res.json();
      setStatus(data);
      setLastRefresh(new Date().toLocaleTimeString());
      if (data.zoneStatus) {
        const z = data.zoneStatus;
        const now = Date.now();
        const newActive = {};
        // Parse zone status for each valve using per-valve sub-objects from status API
        [['d6a1', z.d6a1 || z], ['d83a', z.d83a]].forEach(([valveId, vs]) => {
          if (!vs) return;
          [1,2,3,4].forEach(i => {
            const et = vs[`valve${i}_endtime`];
            if (et && et !== 'undefined' && parseInt(et) > now) {
              const minsLeft = Math.max(1, Math.round((parseInt(et) - now) / 60000));
              newActive[`${valveId}-${i}`] = minsLeft;
            }
          });
        });
        setActiveZones(newActive);
      }
    } catch(e) {}
  }, [token]);

  const fetchSchedules = useCallback(async () => {
    if (!token) return;
    try { setSchedules(await (await fetch(`/api/hubs/${HUB_MAC}/schedules`, { headers: H })).json()); } catch(e) {}
  }, [token]);

  const fetchHistory = useCallback(async () => {
    if (!token) return;
    try { setHistory(await (await fetch(`/api/hubs/${HUB_MAC}/history`, { headers: H })).json()); } catch(e) {}
  }, [token]);

  const fetchWeather = useCallback(async () => {
    try {
      const res = await fetch('https://api.open-meteo.com/v1/forecast?latitude=35.32&longitude=-80.65&daily=precipitation_sum&timezone=America/New_York&forecast_days=3');
      setWeather(await res.json());
    } catch(e) {}
  }, []);

  const fetchAdmin = useCallback(async () => {
    if (!token) return;
    const headers = { Authorization: `Bearer ${token}` };
    try {
      const [users, requests, activity, hubs] = await Promise.all([
        fetch('/admin/users', { headers }).then(r => r.json()),
        fetch('/admin/requests', { headers }).then(r => r.json()),
        fetch('/admin/activity', { headers }).then(r => r.json()),
        fetch('/admin/hubs', { headers }).then(r => r.json()),
      ]);
      setAdminData({ users, requests, activity, hubs });
    } catch(e) { console.error('fetchAdmin error', e); }
  }, [token]);

  const fetchRainDelay = useCallback(async () => {
    if (!token) return;
    try { const d = await (await fetch(`/api/hubs/${HUB_MAC}/raindelay`, { headers: H })).json(); setRainDelay(d.days || 0); } catch(e) {}
  }, [token]);

  useEffect(() => {
    if (!token) return;
    fetchStatus(); fetchSchedules(); fetchWeather(); fetchRainDelay();
    const i = setInterval(fetchStatus, 15000);
    return () => clearInterval(i);
  }, [token]);

  useEffect(() => {
    if (view === 'history') fetchHistory();
    if (view === 'schedule') fetchSchedules();
    if (view === 'admin') fetchAdmin();
  }, [view]);

  const controlValve = async (valveId, zone, duration) => {
    const key = `${valveId}-${zone}`;
    setLoading(l => ({ ...l, [key]: true }));
    try {
      await fetch(`/api/hubs/${HUB_MAC}/control`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', ...H },
        body: JSON.stringify({ valveId, zone, duration })
      });
      if (duration > 0) {
        setActiveZones(a => ({ ...a, [key]: duration }));
        setTimeout(() => setActiveZones(a => { const n={...a}; delete n[key]; return n; }), duration * 60000);
      } else {
        setActiveZones(a => { const n={...a}; delete n[key]; return n; });
      }
    } catch(e) { alert('Failed'); }
    setLoading(l => ({ ...l, [key]: false }));
  };

  const addSchedule = async () => {
    setScheduleError('');
    try {
      const res = await fetch('/api/schedules/interval', {
        method: 'POST', headers: { 'Content-Type': 'application/json', ...H },
        body: JSON.stringify({ ...newSched, mac: HUB_MAC })
      });
      if (!res.ok) {
        const body = await res.json().catch(() => ({}));
        setScheduleError(body.message || body.error || 'Could not save schedule');
        return;
      }
      setShowAddSchedule(false); fetchSchedules();
    } catch(e) { setScheduleError('Network error saving schedule'); }
  };

  const deleteSchedule = async (id) => {
    if (!window.confirm('Delete this schedule?')) return;
    try { await fetch(`/api/schedules/${id}`, { method: 'DELETE', headers: H }); fetchSchedules(); } catch(e) {}
  };

  const setRainDelayFn = async (days) => {
    try {
      await fetch(`/api/hubs/${HUB_MAC}/raindelay`, {
        method: 'POST', headers: { 'Content-Type': 'application/json', ...H },
        body: JSON.stringify({ days })
      });
      setRainDelay(days);
    } catch(e) {}
  };

  const logout = () => { localStorage.removeItem('rc_token'); setToken(null); setUser(null); };

  if (!token) return <AuthScreen />;

  const isOnline = status?.online;
  const rainForecast = weather?.daily?.precipitation_sum || [];
  const willRain = rainForecast.some(r => r > 2);
  const DAYS = ['Sun','Mon','Tue','Wed','Thu','Fri','Sat'];

  return (
    <div className="app">
      <header className="header">
        <div className="header-content">
          <h1>💧 Kishore's RainCloud</h1>
          <div className={`status-badge ${isOnline ? 'online' : 'offline'}`}>
            {isOnline ? '● Online' : '○ Offline'}
          </div>
        </div>
        <div className="header-user">
          <span>👤 {user?.name || ''}</span>
          <button className="logout-btn" onClick={logout}>Logout</button>
        </div>
        {rainDelay > 0 && <div className="rain-delay-banner">🌧 Rain delay: {rainDelay} day{rainDelay>1?'s':''}</div>}
        {willRain && rainDelay === 0 && <div className="rain-warning">🌦 Rain forecast — consider rain delay</div>}
      </header>

      <div className="refresh-bar">
        <span>{lastRefresh ? `Updated: ${lastRefresh}` : 'Loading...'}</span>
        <button className="refresh-btn" onClick={fetchStatus}>↻</button>
      </div>

      <nav className="nav">
        <button className={`nav-btn ${view==='control'?'active':''}`} onClick={() => setView('control')}>Control</button>
        <button className={`nav-btn ${view==='schedule'?'active':''}`} onClick={() => setView('schedule')}>Schedule</button>
        <button className={`nav-btn ${view==='history'?'active':''}`} onClick={() => setView('history')}>History</button>
        {user?.role === 'admin' && <button className={`nav-btn ${view==='admin'?'active':''}`} onClick={() => setView('admin')}>Admin</button>}
      </nav>

      {view === 'control' && (
        <main className="main">
          {!isOnline && <div className="warning-banner">Hub offline</div>}
          {VALVES.map(valve => {
            const vKey = valve.id;
            const selZone = selectedZones[vKey] || 1;
            const selDur = selectedDurs[vKey] || 10;
            const isZoneActive = !!activeZones[`${vKey}-${selZone}`];
            const runningZones = Object.keys(activeZones).filter(k => k.startsWith(vKey));
            return (
            <div key={valve.id} className="valve-card">
              <div className="valve-header">
                <h2>{valve.name}</h2>
                <span className="valve-id">{valve.id.toUpperCase()}</span>
              </div>
              {runningZones.map(k => {
                const z = k.split('-')[1];
                return <div key={k} className="zone-running">💧 Zone {z} — {activeZones[k]}min remaining</div>;
              })}
              <div className="zone-control-row">
                <select className="zone-select" value={selZone}
                  onChange={e => setSelectedZones(s => ({...s, [vKey]: parseInt(e.target.value)}))}>
                  {ZONES.map(z => <option key={z.idx} value={z.idx}>{z.name}</option>)}
                </select>
                <select className="duration-select" value={selDur}
                  onChange={e => setSelectedDurs(s => ({...s, [vKey]: parseInt(e.target.value)}))}>
                  {[1,2,3,4,5,6,7,8,9,10,15,20,25,30,45,60,75,90,105,120].map(d => (
                    <option key={d} value={d}>{d}min</option>
                  ))}
                </select>
                <button className="duration-btn"
                  disabled={!isOnline||rainDelay>0||isZoneActive}
                  onClick={() => controlValve(valve.id, selZone, selDur)}>
                  ▶ Start
                </button>
                <button className="stop-btn" disabled={!isOnline||!isZoneActive}
                  onClick={() => controlValve(valve.id, selZone, 0)}>■</button>

              </div>
            </div>
            );
          })}
          {Object.keys(activeZones).length > 0 && (
            <div className="active-zones-banner">
              <div className="banner-title">💧 Currently watering</div>
              {Object.keys(activeZones).map(k => {
                const [valveId, zone] = k.split('-');
                const valveName = VALVES.find(v => v.id === valveId)?.name || valveId;
                return (
                  <div key={k} className="banner-row">
                    <span>{valveName} - Zone {zone}</span>
                    <span className="remaining">{activeZones[k]} min remaining</span>
                  </div>
                );
              })}
            </div>
          )}
        </main>
      )}

      {view === 'schedule' && (
        <main className="main">
          <div className="schedule-header">
            <h2>Schedules</h2>
            <button className="add-btn" onClick={() => { setScheduleError(''); setShowAddSchedule(true); }}>+ Add</button>
          </div>
          <div className="rain-card">
            <h3>🌧 Rain Delay</h3>
            <div className="rain-buttons">
              {[0,1,2,3,7].map(d => (
                <button key={d} className={`rain-btn ${rainDelay===d?'active':''}`} onClick={() => setRainDelayFn(d)}>
                  {d===0?'Off':`${d}d`}
                </button>
              ))}
            </div>
          </div>
          {showAddSchedule && (
            <div className="add-schedule-card">
              <h3>New Schedule</h3>
              <div className="form-row">
                <label>Valve</label>
                <select value={newSched.valveId} onChange={e => setNewSched({...newSched, valveId: e.target.value})}>
                  {VALVES.map(v => <option key={v.id} value={v.id}>{v.name}</option>)}
                </select>
              </div>
              <div className="form-row">
                <label>Zone</label>
                <select value={newSched.zone} onChange={e => setNewSched({...newSched, zone: parseInt(e.target.value)})}>
                  {ZONES.map(z => <option key={z.idx} value={z.idx}>{z.name}</option>)}
                </select>
              </div>
              <div className="form-row">
                <label>Every</label>
                <select value={newSched.intervalDays} onChange={e => setNewSched({...newSched, intervalDays: parseInt(e.target.value)})}>
                  {[1,2,3,4,7,14].map(d => <option key={d} value={d}>{d===1?'Day':`${d} days`}</option>)}
                </select>
              </div>
              <div className="form-row">
                <label>Times/day</label>
                <select value={newSched.timesPerDay} onChange={e => {
                  const t = parseInt(e.target.value);
                  const slots = Array.from({length: t}, (_,i) => newSched.slots[i] || {time:'06:00', duration:10});
                  setNewSched({...newSched, timesPerDay: t, slots});
                }}>
                  {[1,2,3,4,6,8,12,24].map(t => <option key={t} value={t}>{t===1?'Once':t===2?'Twice':`${t}x`}</option>)}
                </select>
              </div>
              {newSched.slots.map((slot, i) => (
                <div key={i} className="slot-row">
                  <div className="slot-label">{newSched.timesPerDay===1?'Watering time':`Slot ${i+1}`}</div>
                  <div className="slot-inputs">
                    <input type="time" value={slot.time} onChange={e => {
                      const slots=[...newSched.slots]; slots[i]={...slots[i],time:e.target.value}; setNewSched({...newSched,slots});
                    }}/>
                    <select value={slot.duration} onChange={e => {
                      const slots=[...newSched.slots]; slots[i]={...slots[i],duration:parseInt(e.target.value)}; setNewSched({...newSched,slots});
                    }}>
                      {[1,2,3,4,5,6,7,8,9,10,15,20,25,30,45,60,75,90,105,120].map(d => <option key={d} value={d}>{d}min</option>)}
                    </select>
                  </div>
                </div>
              ))}
              {scheduleError && <div className="schedule-error">{scheduleError}</div>}
              <div className="form-actions">
                <button className="cancel-btn" onClick={() => { setScheduleError(''); setShowAddSchedule(false); }}>Cancel</button>
                <button className="save-btn" onClick={addSchedule}>Save</button>
              </div>
            </div>
          )}
          {schedules.length===0 && !showAddSchedule && <div className="empty-state">No schedules yet. Tap + Add.</div>}
          {schedules.map(({valve, schedules: vs}) => vs.map(s => (
            <div key={s.id} className="schedule-card">
              <div className="schedule-info">
                <div className="schedule-name">{VALVES.find(v=>v.id===valve.valve_id)?.name} — Zone {s.zone}</div>
                <div className="schedule-detail">Every {s.interval_days} day{s.interval_days>1?'s':''} at {s.start_time} for {s.duration}min</div>
              </div>
              <button className="delete-btn" onClick={() => deleteSchedule(s.id)}>✕</button>
            </div>
          )))}
        </main>
      )}

      {view === 'history' && (
        <main className="main">
          <div className="schedule-header">
            <h2>Watering History</h2>
            <button className="add-btn" style={{background:'#fc8181'}} onClick={async () => {
              if (!window.confirm('Clear all history?')) return;
              await fetch(`/api/hubs/${HUB_MAC}/history`, { method: 'DELETE', headers: H });
              fetchHistory();
            }}>Clear</button>
          </div>
          {history.length===0 && <div className="empty-state">No watering history yet.</div>}
          {history.map(h => (
            <div key={h.id} className="history-card">
              <div className="history-info">
                <div className="history-name">{h.valve_name} — Zone {h.zone}</div>
                <div className="history-detail">{new Date(h.started_at).toLocaleString()}</div>
              </div>
              <div className="history-duration">{h.duration}min</div>
            </div>
          ))}
        </main>
      )}

      {view === 'admin' && user?.role === 'admin' && (
        <main className="main">
          <h2 style={{padding:'0 4px 8px'}}>Admin Panel</h2>

          {/* Pending Requests */}
          <div className="admin-section">
            <h3>⏳ Pending Requests ({adminData.requests.filter(r=>r.status==='pending').length})</h3>
            {adminData.requests.filter(r=>r.status==='pending').length === 0 && <div className="empty-state">No pending requests</div>}
            {adminData.requests.filter(r=>r.status==='pending').map(r => (
              <div key={r.id} className="admin-card">
                <div className="admin-info">
                  <div className="admin-name">{r.name}</div>
                  <div className="admin-detail">{r.email}</div>
                  <div className="admin-detail">{new Date(r.created_at).toLocaleString()}</div>
                </div>
                <div className="admin-actions">
                  <button className="approve-btn" onClick={async () => {
                    await fetch('/admin/approve', { method:'POST', headers:{'Content-Type':'application/json',...H}, body:JSON.stringify({email:r.email}) });
                    fetchAdmin();
                  }}>✅ Approve</button>
                  <button className="reject-btn" onClick={async () => {
                    await fetch('/admin/reject', { method:'POST', headers:{'Content-Type':'application/json',...H}, body:JSON.stringify({email:r.email}) });
                    fetchAdmin();
                  }}>❌ Reject</button>
                </div>
              </div>
            ))}
          </div>

          {/* Users */}
          <div className="admin-section">
            <h3>👥 Users ({adminData.users.length})</h3>
            {adminData.users.map(u => (
              <div key={u.id} className="admin-card">
                <div className="admin-info">
                  <div className="admin-name">{u.name} {u.role==='admin'?'👑':''}</div>
                  <div className="admin-detail">{u.email}</div>
                  <div className="admin-detail">Hub: {u.hub_mac || 'Not registered'}</div>
                  <div className={`admin-status ${u.status}`}>{u.status}</div>
                </div>
                {u.role !== 'admin' && (
                  <button className={u.status==='active'?'reject-btn':'approve-btn'} onClick={async () => {
                    const action = u.status==='active' ? 'deactivate' : 'activate';
                    if (!window.confirm(`Are you sure you want to ${action} ${u.name}?`)) return;
                    await fetch(`/admin/users/${u.id}/toggle`, { method:'POST', headers:{Authorization:`Bearer ${token}`} });
                    fetchAdmin();
                  }}>{u.status==='active'?'Deactivate':'Activate'}</button>
                )}
              </div>
            ))}
          </div>

          {/* Hubs */}
          <div className="admin-section">
            <h3>🌐 Hubs ({adminData.hubs.length})</h3>
            {adminData.hubs.map(h => (
              <div key={h.id} className="admin-card">
                <div className="admin-info">
                  <div className="admin-name">{h.name}</div>
                  <div className="admin-detail">{h.mac.toUpperCase()}</div>
                  <div className="admin-detail">Owner: {h.user_name}</div>
                </div>
              </div>
            ))}
          </div>

          {/* Activity */}
          <div className="admin-section">
            <h3>📋 Recent Activity</h3>
            {adminData.activity.length === 0 && <div className="empty-state">No activity yet</div>}
            {adminData.activity.slice(0,20).map(a => (
              <div key={a.id} className="admin-card">
                <div className="admin-info">
                  <div className="admin-name">{a.user_name} — Zone {a.zone}</div>
                  <div className="admin-detail">{a.hub_mac?.toUpperCase()} · {a.duration}min</div>
                  <div className="admin-detail">{new Date(a.started_at).toLocaleString()}</div>
                </div>
              </div>
            ))}
          </div>
        </main>
      )}

      <footer className="footer">
        <p>RainCloud · Built by Kishore</p>
      </footer>
    </div>
  );
}
